module.exports = __webpack_public_path__ + "static/media/male.596ece33.png";